import { LocalStorageKeys, LocalStorageTypeMap } from '../types/localStorage';

export class LocalStorageService {
    static getItem<Key extends LocalStorageKeys>(
        key: Key,
    ): LocalStorageTypeMap[Key] | null {
        const storedValue = localStorage.getItem(key);

        if (storedValue === null) {
            return null;
        }

        try {
            return JSON.parse(storedValue);
        } catch (error) {
            console.error(`Error parsing localStorage key "${key}":`, error);
            return null;
        }
    }

    static setItem = <Key extends LocalStorageKeys>(
        key: Key,
        value: LocalStorageTypeMap[Key],
    ): void => {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (error) {
            console.error('Error setting localStorage item:', error);
        }
    };

    static removeItem<Key extends LocalStorageKeys>(key: Key): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing localStorage item:', error);
        }
    }
}
